export const SOCIAL_FOLLOW_INSTAGRAM = 'social.follow.instagram';
export const SOCIAL_FOLLOW_FACEBOOK = 'social.follow.facebook';
export const SOCIAL_FOLLOW_TWITTER = 'social.follow.twitter';
export const SOCIAL_FOLLOW_PINTEREST = 'social.follow.pinterest';
export const SOCIAL_FOLLOW_YOUTUBE = 'social.follow.youtube';
